// Shared client search for every client picker.
//
// - Matches anywhere in the text, not just the start ("group" finds
//   "Padmaja Group Private Limited").
// - Several words are matched independently, in any order ("group padmaja"
//   finds "Padmaja Group Private Limited").
// - Searches name, File No., PAN and Client Group together, but ranks a match
//   in the client's own name above one that only matched via Group/File/PAN —
//   so typing "group" lists clients named "... Group ..." first, and clients
//   that merely belong to some "... Group" after them.

const norm = (v) => String(v ?? '').toLowerCase().replace(/\s+/g, ' ').trim();

function score(c, q, words) {
  const name = norm(c.client_name);
  const other = norm([c.file_number, c.pan, c.group_name, c.trade_name].filter(Boolean).join(' '));
  const all = `${name} ${other}`;
  if (!words.every(w => all.includes(w))) return -1;

  if (name === q) return 100;
  if (name.startsWith(q)) return 90;
  if (name.split(' ').some(part => part.startsWith(q))) return 80;
  if (name.includes(q)) return 70;
  if (words.every(w => name.includes(w))) return 60;
  if (words.some(w => name.includes(w))) return 40;
  return 20; // matched only through File No. / PAN / Group
}

// Generic "every typed word appears somewhere in the text" check, for other
// pickers (ledgers, groups, ...).
export function textMatches(text, query) {
  const words = norm(query).split(' ').filter(Boolean);
  const t = norm(text);
  return words.every(w => t.includes(w));
}

export function searchClients(clients, query) {
  const list = Array.isArray(clients) ? clients : [];
  const q = norm(query);
  if (!q) return list;
  const words = q.split(' ').filter(Boolean);
  return list
    .map((c, i) => ({ c, i, s: score(c, q, words) }))
    .filter(x => x.s >= 0)
    .sort((a, b) => (b.s - a.s) || (a.i - b.i))
    .map(x => x.c);
}
